<div
  class="button-container"
  ngClass.lt-md="mobile">
  <img
    ngClass.lt-md="btn-mobile"
    (click)="handleClick()"
    src="/assets/img/png/001_botón_información_azul.png"
    alt>
</div>
